import { defineTranslationScope } from "@app/shared/i18n/translation-scope";

export const scope = defineTranslationScope("user/user-profile");
